import classNames from 'classnames'

import { TAG_ICON_INITIAL_PROPS } from './constants'
import type { ITagIconProps } from './types'

import './styles.scss'

export default function TagIcon({
  icon,
  children,
  textAlign = TAG_ICON_INITIAL_PROPS.textAlign,
  className,
}: ITagIconProps) {
  return (
    <div className={classNames('TagIcon', { 'TagIcon-withIcon': icon }, className)}>
      {icon}
      <p className="TagIcon-text" style={{ textAlign }}>
        {children}
      </p>
    </div>
  )
}
